<template>
    <b-form
      @submit.prevent="submitContactForm"
      method="post"
      class="review-form"
      style="text-align: left"
      ref="contactForm"
      v-if="show"
    >
      <!-- FULLNAME INPUT HIDDEN -->
      <b-input-group v-if="false">
        <span class="formIcons">
          <UserIcon />
        </span>
        <b-form-input
          class="input-box-area"
          id="name-input-1"
          ref="nameInput"
          name="name-input-1"
          size="lg"
          placeholder="NAME"
          v-model="$v.form.name.$model"
          :state="validateState('name')"
          aria-describedby="input-1-name-feedback"
          disabled
        ></b-form-input>

        <b-form-invalid-feedback id="input-1-name-feedback"
          >This is a required field and must be at least 3
          characters.</b-form-invalid-feedback
        >
      </b-input-group>

      <!-- EMAIL INPUT HIDDEN -->
      <b-input-group v-if="false">
        <span class="formIcons email">
          <EmailIcon />
        </span>
        <b-form-input
          class="input-box-area"
          id="email-input-2"
          name="email-input-2"
          size="lg"
          placeholder="E-MAIL"
          v-model="$v.form.email.$model"
          :state="validateState('email')"
          aria-describedby="input-2-email-feedback"
          disabled
        ></b-form-input>

        <b-form-invalid-feedback id="input-2-email-feedback"
          >This is a required field and must be a valid
          e-mail.</b-form-invalid-feedback
        >
      </b-input-group>

      <!-- SUBJECT INPUT HIDDEN-->
      <b-input-group v-if="false">
        <span class="formIcons subject">
          <SubjectIcon />
        </span>
        <b-form-input
          class="input-box-area"
          id="subject-input-3"
          name="subject-input-3"
          size="lg"
          placeholder="SUBJECT"
          v-model="$v.form.subject.$model"
          :state="validateState('subject')"
          aria-describedby="input-3-subject-feedback"
        ></b-form-input>

        <b-form-invalid-feedback id="input-3-subject-feedback"
          >This is a required field and must be at least 3
          characters.</b-form-invalid-feedback
        >
      </b-input-group>

      <!-- MESSAGE INPUT -->
      <b-input-group>
        <span class="formIcons message">
          <MessageIcon />
        </span>
        <b-form-textarea
          class="input-box-area textarea-box-area"
          id="message-input-4"
          name="message-input-4"
          size="lg"
          rows="6"
          :placeholder="computedPlaceholder"
          v-model="$v.form.message.$model"
          :state="validateState('message')"
          aria-describedby="input-4-message-feedback"
        ></b-form-textarea>

        <b-form-invalid-feedback id="input-4-message-feedback"
          >This is a required field and must be at least 3
          characters.</b-form-invalid-feedback
        >
      </b-input-group>

      <div class="toast-container">
        <b-toast
          title="Thank You!"
          id="messageSent"
          variant="success"
          static
          solid
          auto-hide-delay="7000"
          no-close-button
        >
          {{ FormWasSentMessage }}
        </b-toast>
        <b-toast
          title="Sorry!"
          id="messageNotSent"
          variant="danger"
          static
          solid
          auto-hide-delay="7000"
          no-close-button
        >
          {{ FormWasntSentMessage }}
        </b-toast>
      </div>

      <button class="button-review-form" type="submit" id="submitButton">
        <b-spinner small v-show="showLoad"></b-spinner>
        <span class id="button-text" v-if="!showLoad">{{rightButton}}</span>
      </button>
    </b-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { email, required, minLength } from "vuelidate/lib/validators";
import { BACKEND_URL } from "@/config.js";
import UserIcon from "@/components/icons/UserIcon.vue";
import EmailIcon from "@/components/icons/EmailIcon.vue";
import SubjectIcon from "@/components/icons/SubjectIcon.vue";
import MessageIcon from "@/components/icons/MessageIcon.vue";

export default {
  name: "ReviewForm",
  components: {
    UserIcon,
    EmailIcon,
    SubjectIcon,
    MessageIcon,
  },
  props: ["customerInfo", "rightButton", "messageTitle"],
  mixins: [validationMixin],
  data() {
    return {
      form: {
        name:
          JSON.parse(sessionStorage.getItem("customerInfo")).user.firstName +
          " " +
          JSON.parse(sessionStorage.getItem("customerInfo")).user.lastName,
        email: JSON.parse(sessionStorage.getItem("customerInfo")).user.email,
        subject: this.messageTitle,
        message: null,
      },
      show: true,
      showLoad: false,
      FormWasSentMessage:
        "Your review was shared with us successfully.",
      FormWasntSentMessage:
        "Sorry, but we were unable to send your message now. Please, try again later.",
      placeholder: 'Start typing here...'
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
      },
      subject: {
        required,
        minLength: minLength(3),
      },
      message: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    computedPlaceholder() {
      if (this.$route.name === 'Academy' && this.$route.query.category === 'MasterApp' && this.$route.query.step < 18) {
        return 'I use Dropsmart for...'
      } else if (this.$route.name === 'Academy' && this.$route.query.category === 'ProTips' && this.$route.query.step > 18) {
        return 'Before I used Dropsmart...'
      } else if (this.$route.name === 'Premium' && this.$route.query.category === 'SeasonalGifts' && (this.$route.query.id === 4 || this.$route.query.id === 5 || this.$route.query.id === 11)) {
        return 'I use Dropsmart for...'
      } else if (this.$route.name === 'Premium' && this.$route.query.category === 'SpecialGuests' && this.$route.query.id === 3 || this.$route.query.id === 10) {
        return 'I use Dropsmart for...'
      } else if (this.$route.name === 'Premium' && this.$route.query.category === 'Masterclasses' && this.$route.query.id === 6) {
        return 'I use Dropsmart for...'
      }
      return this.placeholder;
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    submitContactForm() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      this.showLoad = true;

      let customer = sessionStorage.getItem("customerInfo");
      var jwt = null;
      if (customer) {
        jwt = JSON.parse(customer).token.token;
      }
      let reqHeaders = { "Content-type": "application/json" };
      if (jwt) {
        reqHeaders["Authorization"] = jwt;
      }

      let jsonForm = JSON.stringify(this.form);

      const url = BACKEND_URL.ContactFormMessage;

      console.log("SUBMITING THE FORM " + url);

      fetch(url, {
        method: "POST",
        mode: "cors",
        body: jsonForm,
        headers: reqHeaders,
        cache: "no-cache",
      })
        .then((response) => {
          if (response.ok) {
            this.showLoad = false;
            this.$bvToast.show("messageSent");
          } else {
            this.showLoad = false;
            this.$bvToast.show("messageNotSent");
            throw Error(response.status + ": " + response.statusText);
          }
        })
        .catch((error) => {
          this.showLoad = false;
          console.error(error);
        });

      // Reset some form values
      this.form.subject = "Leave your review";
      this.form.message = null;
      // Reset/clear native browser form validation state
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
  },
};
</script>

<style scoped lang="scss">
// Form Settings
$border-input: 0.12rem solid #000000;
$color-input: #000000;
$font-size-input: 18px;
$color: #000000;
$line-height-input: 23px;
$padding-input: 15px 18px 15px 55px;

// Icon Settings
$icon-color: #999999;

//form 
form {
  max-width: 100%;
}

.formIcons {
  &.subject,
  &.message {
    svg {
      width: 19px;
      margin-left: 20px;
    }
  }
}

.input-box-area {
  background: none;
  background-image: none;
  border: $border-input;
  border-radius: 6px;
  color: $color-input;
  font-size: $font-size-input;
  height: auto;
  line-height: $line-height-input;
  padding: $padding-input;
  resize: none;

  &:focus {
    background-color: #ffffff;
    border: 1px solid #dcdcdc;
  }
}

textarea.textarea-box-area {
  border-radius: 6px !important;
}

.button-review-form {
  background: $color;
  color: #ffffff;
  border: none;
  border-radius: 0.4rem;
  width: 100%;
  font-size: 1rem;
  font-weight: 700;
  padding: 8px;
  line-height: 25px;
}

.button-review-form:hover {
  background: #E7E7E7;
  color: $color;
}

.button-review-form:active,
.button-review-form:focus {
  background: #000000 !important;
  color: #ffffff !important;
  border-color: #000000 !important;
  box-shadow: none !important;
  outline: none;
}
.button-review-form:disabled {
  background: #79b867 !important;
  color: white;
}

.positive-feedback,
.negative-feedback {
  margin-top: 2rem;
  margin-bottom: 0;
  text-align: center;
  font-weight: 600;
}

form .b-toast {
  width: auto;
}

.toast-container {
  display: flex;
  justify-content: center;
  margin: 1.2rem 0;

  #messageSent.toast,
  #messageNotSent.toast {
    margin: auto;
  }
}

@media screen and (max-width: 767px) {
  form {
    font-size: 16px;
    .input-group {
      input,
      textarea {
        font-size: 16px;
      }
    }
  }
  .button-review-form {
    font-size: 18px;
  }

  .boxContactForm {
    border: 0;
    padding: 0;
  }
}
</style>
